import { render } from "./CreateWorkspaceSideBar.vue?vue&type=template&id=69398eda"
import script from "./CreateWorkspaceSideBar.vue?vue&type=script&lang=js"
export * from "./CreateWorkspaceSideBar.vue?vue&type=script&lang=js"

import "./CreateWorkspaceSideBar.vue?vue&type=style&index=0&id=69398eda&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__